import React from "react";
import HelpTooltip from "../HelpTooltip.jsx";

/**
 * Label- oder Spaltenkopftext mit angehängtem Erklär-Tooltip - ein
 * gemeinsamer Baustein, damit Platzierung und Größe des Fragezeichens in der
 * ganzen Vertriebsauswertung gleich aussehen (Filterlabels, Tabellenköpfe,
 * Kundenkopf-Felder).
 */
export default function HeaderWithHelp({children, help, placement = "top", className = ""}) {
    return (
        <span className={`d-inline-flex align-items-center gap-1${className ? " " + className : ""}`}>
            {children}
            {help && (
                <HelpTooltip placement={placement} size={0.7}>
                    {help}
                </HelpTooltip>
            )}
        </span>
    );
}
